import { defaultPitch } from './pitch'
import { pitchSetupTypes } from '../../pitches/data_types'

export const rugbyUnionProps = {
  reportMetricConfig: {
    playerPerformanceTable: {
      all: {
        metrics: {
          keys: []
        },
        eventMetricGroup: {
          eventTypes: [],
          groupName: {
            en: 'Success %',
            fr: 'Succès %'
          }
        }
      }
    },
    playerComparisonTable: {
      pass: {
        metrics: [[], [], []]
      }
    },
    monitoringCards: {
      technicalMetrics: [],
      physicalMetrics: []
    },
    dashboardMetrics: {
      performanceAgainstAverage: [],
      cardGrid: [[], []]
    }
  },
  pitch: {
    default: defaultPitch,
    defaultDoublePitch: null,
    pitchPointCount: 34,
    setupTypes: pitchSetupTypes,
    minPadding2D: 80,
    minPadding3D: 50,
    cameraYScale: 0.5,
    textureCanvasScale: 11,
    crossfieldLines: [
      { name: 'Try line', lower: 'P2', upper: 'P25' },
      { name: '5 meter line', lower: 'P3', upper: 'P24' },
      { name: '22 meter line', lower: 'P4', upper: 'P23' },
      { name: '10 meter line', lower: 'P5', upper: 'P22' },
      { name: 'Halfway line', lower: 'P6', upper: 'P21' },
      { name: '10 meter line', lower: 'P7', upper: 'P20' },
      { name: '22 meter line', lower: 'P8', upper: 'P19' },
      { name: '5 meter line', lower: 'P9', upper: 'P18' },
      { name: 'Try line', lower: 'P10', upper: 'P17' }
    ],
    enableBench: true,
    enableRotate: false,
    defaultDrillRegion: {
      P1: 'P25',
      P2: 'P17',
      P3: 'P10',
      P4: 'P2',
      P5: 'P32',
      P6: 'P33',
      P7: 'P31',
      P8: 'P34'
    } as const,
    drillsGoalsOrPosts: {
      enabled: false,
      dimensions: {
        large: {
          width: 7.32,
          height: 2.44,
          depth: 2.44
        },
        small: {
          width: 1.914,
          height: 1.914,
          depth: 1.61
        }
      }
    },
    drillSnapLines: [
      'P1',
      'P2',
      'P3',
      'P4',
      'P5',
      'P6',
      'P7',
      'P8',
      'P9',
      'P10',
      'P11'
    ],
    autosetupTagPositions: ['P6', 'P10', 'P19'],
    pitchCornerKeys: {
      topLeft: 'P26',
      topRight: 'P16',
      bottomRight: 'P11',
      bottomLeft: 'P1'
    },
    leftAutosetupRegion: {
      topLeft: 'P26',
      topRight: 'P20',
      bottomRight: 'P7',
      bottomLeft: 'P1'
    },
    rightAutosetupRegion: {
      topLeft: 'P22',
      topRight: 'P16',
      bottomRight: 'P11',
      bottomLeft: 'P5'
    },
    leftTeamRegion: {
      topLeft: 'P26',
      topRight: 'P25',
      bottomRight: 'P2',
      bottomLeft: 'P1'
    },
    rightTeamRegion: {
      topLeft: 'P17',
      topRight: 'P16',
      bottomRight: 'P11',
      bottomLeft: 'P10'
    }
  },
  features: {
    enablePromoteAllDevices: true,
    targetEvents: ['kick'],
    positionNumbers: true,
    maxPlayers: 23,
    defaultUnitSystem: 'British',
    recentEventTableMetrics: [
      'inPitchDistance',
      'inPitchHangTime',
      'speed',
      'territorialGain'
    ],
    geniusAvailable: false,
    noOfPlayersInStartingLineUp: null,
    homeSideCheck: false,
    scoreboard: true,
    bibs: {},
    defaultBibTeamDirection: [] as number[]
  } as const
}

export const rugbyUnionConfig = {
  key: 'rugbyUnion' as const,
  value: 'RugbyUnion' as const,
  name: 'Rugby Union',
  props: rugbyUnionProps
}
